import { render, staticRenderFns } from "./InfiniteScrolling.vue?vue&type=template&id=13cc9235&"
import script from "./InfiniteScrolling.vue?vue&type=script&lang=js&"
export * from "./InfiniteScrolling.vue?vue&type=script&lang=js&"
import style0 from "./InfiniteScrolling.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports